
import { Component, OnInit, Inject, ElementRef, NgZone, ViewChild } from '@angular/core';
import { DealershipService } from '../services/dealership.service';
import { DealershipOverview, DealerGroupV } from '../models/dealership.model';
import { CustomerServiceIdentity } from '../services/customer.service';
import { ReportStyle, UpdateCustomer, ReportRetrieveOptions } from '../models/customer.model';
import { FormControl } from '@angular/forms';
// import { } from 'googlemaps';
//import { MapsAPILoader } from '@agm/core';
import { NotificationsService } from 'angular2-notifications';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'edit-customer-modal',
    templateUrl: './edit-customer-modal.component.html',
    styleUrls: ['./edit-customer-modal.component.scss']
})
export class EditCustomerModalComponent implements OnInit {
    customerId: number = 0;
    dealerships: DealershipOverview[];
    dealergroups: DealerGroupV[];
    selectedDealershipId: number = 0;
    selectedDealerGroupId: number = 0;
    imageUrl: string = '';
    safeImageUrl: SafeResourceUrl;
    imageHasChanged: boolean = false;

    reportStyles: ReportStyle[];
    selectedReportStyleId: number;


    ropereportStyles: ReportStyle[];
    ropeselectedReportStyleId: number;

    wearreportStyles: ReportStyle[];
    wearselectedReportStyleId: number;

    wsrereportStyles: ReportStyle[];
    wsreselectedReportStyleId: number;

    quoteReportStyles :ReportStyle [];
    selectedQuoteReportStyleId : number;


    hourlyRate: number;


    public searchControl: FormControl;
    @ViewChild("search")
    public searchElementRef: ElementRef;

    // 2 way binding form inputs
    customerName: string = '';
    customerReference:string='';
    phoneNumber: string = '';
    email: string = '';
    address: string = '';
    logoUrl: string = '';

    updatingCustomer: boolean = false;
    loadingCurrentDetails: boolean = true;

    rdThemorgrphyEnable:number =2
    themorgraphyEnabled:boolean=false;

    customerNameValid:boolean=true;
    isRepairer:boolean=false;
    isBasicUser:number=1;
    showAll:boolean=true;
    constructor(public dialogRef: MatDialogRef<EditCustomerModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
        private _dealershipService: DealershipService, private _customerService: CustomerServiceIdentity, //private mapsAPILoader: MapsAPILoader,
        private ngZone: NgZone, public snackBar: MatSnackBar, private _notifications: NotificationsService,
        private sanitizer: DomSanitizer) { }
        
    ngOnInit() {

        this._customerService.CheckThermographyEnable().subscribe(result => {
            this.themorgraphyEnabled = result;
        });

        this._customerService.CheckUCUserType().subscribe(result => {
            this.isBasicUser = result;
            if(this.isBasicUser==1)this.showAll=true
            else this.showAll=false;
        });
        if (this.data != null) {
            this.customerId = this.data.customerId;
        }
        this._dealershipService.getAllDealerships().subscribe(result => {
            this.dealerships = result;
            this.loadCurrentDetails();
        });
        this._dealershipService.getAllDealerGroups().subscribe(result => {
            this.dealergroups = result;
        });
        this.searchControl = new FormControl();
    }

    initializeMaps() {
        // this.mapsAPILoader.load().then(() => {
        //     let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        //         types: ["address"]
        //     });
        //     google.maps.event.addListener(autocomplete, 'place_changed', () => {
        //         this.ngZone.run(() => {
        //             let place = autocomplete.getPlace();
        //             this.address = place.formatted_address;
        //         });
        //     });
        // });
    }
    ShowAllFields(){
        this.showAll=true;
    }
    loadCurrentDetails() {
        this._customerService.getCustomerDetails(this.customerId).subscribe(customer => {
            this._customerService.getReportStyleForCustomerByDealership(this.customerId,customer.DealershipId, ReportRetrieveOptions.ConditionReport).subscribe(result => {
                this.reportStyles = result;
                this.safeImageUrl = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + customer.Logo);
                this.selectedDealershipId = customer.DealershipId;
                this.selectedDealerGroupId = customer.DealerGroupId;
                this.customerName = customer.CustomerName;
                this.phoneNumber = customer.PhoneNumber;
                this.email = customer.Email;
                this.address = customer.Address;
                this.selectedReportStyleId = customer.ReportStyleId;
                this.imageUrl = customer.Logo;
                this.hourlyRate = customer.HourlyLabourCost;
                this.selectedQuoteReportStyleId = customer.QuoteReportStyleId;
                this.loadingCurrentDetails = false;
                this.ropeselectedReportStyleId = customer.RopeReportStyleId;
                this.wearselectedReportStyleId=customer.WearReportStyleId;
                this.wsreselectedReportStyleId=customer.WsreReportStyleId;
                this.rdThemorgrphyEnable=customer.ThermographyEnable;
                this.isRepairer=customer.IsRepairer;
                this.customerReference=customer.customerReference;

                this.initializeMaps();
            });

            this._customerService.getReportStyleForCustomerByDealerGroup(customer.DealerGroupId, ReportRetrieveOptions.QuoteReport).subscribe(r=>{
                this.quoteReportStyles = r;
            });

            this._customerService.getReportStyleForCustomerByDealerGroup(customer.DealershipId, ReportRetrieveOptions.RopeReport).subscribe(r=>{
                this.ropereportStyles = r;
            });

            this._customerService.getReportStyleForCustomerByDealerGroup(customer.DealershipId, ReportRetrieveOptions.WearReport).subscribe(r=>{
                this.wearreportStyles = r;
            });

            this._customerService.getReportStyleForCustomerByDealerGroup(customer.DealershipId, ReportRetrieveOptions.WsreReport).subscribe(r=>{
                this.wsrereportStyles = r;
            });


        });
    }
    validateCustomerName() {
   
        this._customerService.validateCustomerNameDealerGroupCustomerID(this.selectedDealershipId, this.customerName, this.customerId).subscribe(qr => {
            this.customerNameValid = qr;
        });
      }
    onNoClick(): void {
        this.dialogRef.close();
    }

    dealershipSelected(dealershipId) {
        this.loadReportsForDealership(dealershipId);
    }
    dealerGroupSelected(dealerGroupId) {
        this._customerService.getReportStyleForCustomerByDealerGroup(dealerGroupId, ReportRetrieveOptions.ConditionReport).subscribe(result => {
            this.reportStyles = result;
        });
        this._customerService.getReportStyleForCustomerByDealerGroup(dealerGroupId, ReportRetrieveOptions.QuoteReport).subscribe(r=>{
            this.quoteReportStyles = r;
        });

        this._customerService.getReportStyleForCustomerByDealerGroup(dealerGroupId, ReportRetrieveOptions.RopeReport).subscribe(result => {
            this.ropereportStyles = result;
        });

        this._customerService.getReportStyleForCustomerByDealerGroup(dealerGroupId, ReportRetrieveOptions.WearReport).subscribe(result => {
            this.wearreportStyles = result;
        });

        this._customerService.getReportStyleForCustomerByDealerGroup(dealerGroupId, ReportRetrieveOptions.WsreReport).subscribe(result => {
            this.wsrereportStyles = result;
        });
    }
    loadReportsForDealership(dealershipId) {
        this._customerService.getReportStyleForCustomerByDealership(0, dealershipId,ReportRetrieveOptions.ConditionReport).subscribe(result => {
            this.reportStyles = result;
        });
        this._customerService.getReportStyleForCustomerByDealership(0, dealershipId,ReportRetrieveOptions.QuoteReport).subscribe(r => {
            this.quoteReportStyles = r;
        });

        this._customerService.getReportStyleForCustomerByDealership(0, dealershipId,ReportRetrieveOptions.RopeReport).subscribe(result => {
            this.ropereportStyles = result;
        });

        this._customerService.getReportStyleForCustomerByDealership(0, dealershipId,ReportRetrieveOptions.WearReport).subscribe(result => {
            this.wearreportStyles = result;
        });
        
        this._customerService.getReportStyleForCustomerByDealership(0, dealershipId,ReportRetrieveOptions.WsreReport).subscribe(result => {
            this.wsrereportStyles = result;
        });
    }

    onSelectImage(event) {
        if (event.target.files && event.target.files[0]) {
            var reader = new FileReader();

            reader.readAsDataURL(event.target.files[0]); // read file as data url

          reader.onload = (event: any) => { // called once readAsDataURL is completed
                this.imageUrl = event.target["result"];
                this.imageHasChanged = true;
            }
        }
    }

    updateCustomer() {
        if (this.updatingCustomer)
            return;
        if (this.customerName.length < 1 || this.selectedReportStyleId < 1) {
            this.snackBar.open('Please fill in all required fields (*)', '', {
                duration: 1500,
            });
            return;
        }
        this.updatingCustomer = true;
        let logoUrl2 = this.imageHasChanged ? this.imageUrl : '';
        let newCustomer: UpdateCustomer = {
            CustomerId: this.customerId,
            Address: this.address,
            CustomerName: this.customerName,
            DealershipId: this.selectedDealershipId,
            DealerGroupId: this.selectedDealerGroupId,
            Email: this.email,
            ReportStyleId: this.selectedReportStyleId,
            PhoneNumber: this.phoneNumber,
            Logo: logoUrl2,
            CreatedByUserId: 0,
            QuoteReportStyleId: this.selectedQuoteReportStyleId,
            HourlyLabourCost : this.hourlyRate,
            RopeReportStyleId:this.ropeselectedReportStyleId,
            WearReportStyleId:this.wearselectedReportStyleId,
            WsreReportStyleId:this.wsreselectedReportStyleId,

            ThermographyEnable:this.rdThemorgrphyEnable,
            IsRepairer:this.isRepairer,
            customerReference:this.customerReference,
        };
        this._customerService.updateCustomer(newCustomer).subscribe(result => {
            this.updatingCustomer = false;
            if (!result.m_Item1) {
                this._notifications.error('Failed', result.m_Item2);
            } else {
                this._notifications.success('Updated', 'This customer has been updated successfully. ');
                this.dialogRef.close(true);
            }
        });
    }
}

interface FileReaderEventTarget extends EventTarget {
    result: string
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;
    getMessage(): string;
}
